import { PROJECT_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';
const _axios = HttpService.getAxiosClient();

export const getProjectById = async (projectId, pageNo, pageSize) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/projects?projectId=${projectId}&pageNumber=${pageNo}&pageSize=${pageSize}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getProjectsByName = async (
  projectName,
  pageNo,
  pageSize,
  searchBy = 'projectName',
) => {
  try {
    const nameParam = projectName
      ? searchBy === 'employeeName'
        ? 'employeeName=' + projectName + '&'
        : 'projectName=' + projectName + '&'
      : '';
    const response = await _axios.get(
      `${PROJECT_PATH}/projects?${nameParam}${
        pageSize ? 'pageSize=' + pageSize + '&' : ''
      }${pageNo >= 0 ? 'pageNumber=' + pageNo : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const addProjectsAndEmployees = async (project) => {
  try {
    const response = await _axios.post(`${PROJECT_PATH}/projects`, project);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const updateProjectsAndEmployees = async (project) => {
  try {
    const response = await _axios.put(`${PROJECT_PATH}/projects`, project);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const updateProject = async (updatedProject) => {
  try {
    const response = await _axios.put(
      `${PROJECT_PATH}/projects`,
      updatedProject,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getEmployeesInProject = async (projectId, projectStatus) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/projects/${projectId}/users?${projectStatus ? 'projectStatus=' + projectStatus + '&' : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const addEmployeeToProject = async (employee) => {
  try {
    const response = await _axios.post(
      `${PROJECT_PATH}/projects/users`,
      employee,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const updateEmployeeToProject = async (updatedEmployee) => {
  try {
    const response = await _axios.put(
      `${PROJECT_PATH}/projects`,
      updatedEmployee,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
